import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PrimaryTable from '../../helpers/primary-table'
import ReactLoading from 'react-loading';
import { catchError } from '../../helpers/catch-error-case-manager'
import { getStatus } from '../../helpers/common'
import Select from 'react-select';






const WorkOrdersCaseManager = () => {
    const navigate = useNavigate();
    const [woSearch, setWoSearch] = useState(false);
    const [workOrders, setWorkOrders] = React.useState(null);
    const [isLoading, setIsLoading] = useState(false);

    var columns = React.useMemo(
        () => [
            {
                accessorFn: row => <a href={"/case-manager/work-order/" + row.work_order_id} className="btn btn-link" >{"MRA-" + row.work_order_id}</a>,
                id: "work_order_id",
                cell: info => info.getValue(),
                header: () => "ORDER #",
            },
            {
                accessorFn: row => row.wo_creation_date_days > 14 ? row.wo_creation_date + "_ 2 Weeks+" : row.wo_creation_date + "_" + row.wo_creation_date_days + " day(s)",
                id: "wo_creation_date",
                cell: ({ getValue }) => (
                  <span>
                    <ul className="table-ul">
                      {(getValue().split("_")).map((p, index) => (
                        <li key={index}>{p}</li>
                      ))}
                    </ul>
                  </span>
                ),
                header: () => "Date",
                footer: props => props.column.id
              },
            {
                accessorFn: row => row.patient_last_name + " " + row.patient_first_name,
                id: "patient",
                cell: info => info.getValue(),
                header: () => "PATIENT",
                footer: props => props.column.id
            },
            {
                accessorKey: "wo_order_type",
                header: "ORDER TYPE",
                footer: props => props.column.id
            },
            {
                accessorKey: "facility_name",
                header: "FACILITY",
                footer: props => props.column.id
            },
            {
                accessorKey: "client_company_name",
                header: "CREATED BY",
                footer: props => props.column.id
            },
            {
                accessorFn: row => getStatus(row.status ) +"_"+ ((row.invoice_amount>0)?"INVOICE AMT: $" + row.invoice_amount:""),
                id: "status",
                cell: ({ getValue }) => (
                    <span>
                        <ul className="table-ul">
                            {(getValue().split("_")).map((p, index) => (
                                <li key={index} className={index == 1 ? "fw-bold" : ""}>{p}</li>
                            ))}
                        </ul>
                    </span>
                ),
                header: () => "STATUS",
                footer: props => props.column.id
            }
        ],
        []
    )

   





    const searchWorkOrders = () => {

        setIsLoading(true);
       
        var search_elements = {}
        search_elements.start_date = woSearch?.start_date;
        search_elements.end_date = woSearch?.end_date;
        search_elements.report_type = woSearch?.report_type;
        search_elements.status = woSearch?.status;

     

        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/case-manager/get-report-work-orders-case-manager", search_elements, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setWorkOrders(response?.data?.work_orders);

            }
            else {

                setWorkOrders(null);

            }
            setIsLoading(false);


        }).catch(function (error) {

            // setIsBtn(false);
            catchError(error, navigate)

        });


    }


    return (
        <>

            <div className="row pb-2 mt-4">
                <div className="col-md-12 col-sm-12 ps-3 ">
                    <h3 className="text-dark my-0">WORK ORDER REPORT </h3>
                </div>


            </div>

            <div className="card card-form card-primary mt-4 pb-2">
                <div className="card-body">
                    <form className="form-horizontal form-thick mb-2"  >

                        <div className="row px-3 gx-3">

                        

                            <div className="col-xl-2 col-lg-2 col-sm-2 col-2 my-1">
                                <label htmlFor="invoice_date_range">START DATE</label>

                                <DatePicker name="start_date" id="start_date" type="text"
                                    className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selectsStart
                                    isClearable={true}
                                    selected={woSearch?.start_date}
                                    onChange={(e) => {
                                        var dt = new Date(e);

                                        const year = dt.getFullYear();
                                        const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                                        const day = dt.getDate().toString().padStart(2, "0");
        
                                        const formatted_date = month + '/' + day + '/' + year
        
                                        setWoSearch({ ...woSearch, start_date: formatted_date })
                                        
                                    }
                                    }
                                />
                            </div>
                            <div className="col-xl-2 col-lg-2 col-sm-2 col-2 my-1">
                                <label htmlFor="invoice_date_range">END DATE</label>

                                <DatePicker name="end_date" id="end_date" type="text"
                                    className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selectsEnd
                                    isClearable={true}
                                    selected={woSearch?.end_date}
                                    onChange={(e) => {
                                        var dt = new Date(e);

                                        const year = dt.getFullYear();
                                        const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                                        const day = dt.getDate().toString().padStart(2, "0");
        
                                        const formatted_date = month + '/' + day + '/' + year
        
                                        setWoSearch({ ...woSearch, end_date: formatted_date })

                                    }
                                    }
                                />
                            </div>



                            <div className="col-xl-2 col-lg-2 col-sm-2 col-2 my-1">
                                <label htmlFor="wo_order_type" >Type</label>
                                <select name="report_type" className="form-select" type="text"
                                    value={woSearch?.report_type}
                                    onChange={(e) =>
                                        setWoSearch({ ...woSearch, report_type: e.target.value })
                                    }
                                >
                                    <option value=""></option>
                                          <option value="0">Work Orders</option>
                                          <option value="1">Invoices</option>
                                </select>
                            </div>
                            <div className="col-xl-2 col-lg-2 col-sm-2 col-2 my-1">
                                <label htmlFor="status">Status</label>
                                <select name="status" className="form-select" type="text"
                                    value={woSearch?.status}
                                    onChange={(e) =>
                                        setWoSearch({ ...woSearch, status: e.target.value })
                                    }
                                >
                                          <option value="" selected="">All</option>
                             <option value="1">Open, not invoiced yet</option>
                             <option value="4">Open, records Obtained</option>
                             <option value="7">Closed</option>
                                </select>
                            </div>


                        </div>


                    </form>

                </div>

                <div className="card-footer">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-sm-12 text-center">
                            <button onClick={() => searchWorkOrders()} className="btn btn-success mx-1" type="button"  disabled={isLoading?true:false} >{isLoading?<><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></>:"SEARCH"} </button>
                            <button onClick={() => { setWorkOrders(null) }} className="btn btn-warning mx-1" type="button">CLEAR SEARCH </button>
                        </div>

                    </div>
                </div>
            </div>




            {(workOrders || isLoading) &&

                <div className="card card-form card-primary mt-4 " >
                    <div className="card-body p-0 mb-0" >

                        {isLoading ?
                            <div className="loader">
                                <ReactLoading type={"cylon"} color={"#E4F0FD"} height={250} width={250} />
                            </div>
                            :
                            <PrimaryTable columns={columns} data={workOrders} />
                        }


                    </div>
                </div>

            }


        </>


    );
};

export default WorkOrdersCaseManager;